import { CatalogItem } from '../../domain/catalogItem'
import { TemplateItem } from '../../domain/catalogTemplate'
import { ActualItem, EstimatedItem, withoutItemRecovery } from '../../domain/workareaItem'
import API from '../api'

export type GetJobWorkareaItemsResponse = {
  estimatedItems: EstimatedItem[],
  actualItems: ActualItem[],
  catalogItems: CatalogItem[],
  templateItems: TemplateItem[]
}

export const getJobItems = async (jobId: number): Promise<GetJobWorkareaItemsResponse> => {
  const response = await API.get<GetJobWorkareaItemsResponse>(`/web/workarea-items/job/${jobId}`)
  return {
    ...response.data,
    estimatedItems: response.data.estimatedItems.map(withoutItemRecovery),
    actualItems: response.data.actualItems.map(withoutItemRecovery)
  }
}

export type UpdateJobItemsRequest = {
  addedEstimatedItems: EstimatedItem[],
  addedActualItems: ActualItem[],
  updatedEstimatedItems: EstimatedItem[],
  updatedActualItems: ActualItem[],
  deletedItems: string[]
}

export const updateJobItems = async (jobId: number, request: UpdateJobItemsRequest) => {
  await API.post(`/web/workarea-items/job/${jobId}`, {
    ...request,
    addedEstimatedItems: request.addedEstimatedItems.map(withoutItemRecovery),
    addedActualItems: request.addedActualItems.map(withoutItemRecovery),
    updatedEstimatedItems: request.updatedEstimatedItems.map(withoutItemRecovery),
    updatedActualItems: request.updatedActualItems.map(withoutItemRecovery)
  })
}